import _ from 'lodash';
import { ModalProvider, BaseModalBackground } from 'styled-react-modal';
import { ThemeProvider } from 'styled-components';
import { getTheme } from './styles/theme.js'
import React, { useReducer } from 'react';
import styled from 'styled-components';
import loanevents, { STEPS } from './services/loanevents'

const TYPES = {
    SET_ERROR: 'SET_ERROR',
    UNSET_ERROR: 'UNSET_ERROR',
    STEP_FORWARD: 'STEP_FORWARD',
    STEP_BACKWARDS: 'STEP_BACKWARDS',
    SET_STEP: 'SET_STEP',
    SET_USER_DATA: 'SET_USER_DATA',
    OPEN_MODAL: 'OPEN_MODAL',
    CLOSE_MODAL: 'CLOSE_MODAL',
    SAVE_PHOTO: 'SAVE_PHOTO',
    CLEAR_PHOTO: 'CLEAR_PHOTO',
    SET_SIGN_CANVAS: 'SET_SIGN_CANVAS',
    LOADING: 'LOADING',
    SEND_PHOTO: 'SEND_PHOTO',
    SET_TOKEN: 'SET_TOKEN',
    SET_OPERATION: 'SET_OPERATION',
    SET_ATTEMP: 'SET_ATTEMP',
    DISCOUNT_ATTEMP: 'DISCOUNT_ATTEMP',
    SET_FACE_LIVENESS_IMAGE: 'SET_FACE_LIVENESS_IMAGE',
};

const PAGES = {
    1: 'WELCOME',
    2: 'CONTRACT',
    3: 'DNI',
    4: 'FACELIVENESS',
    5: 'SELFIE_INTRO',
    6: 'SELFIE_NEUTRAL',
    7: 'SELFIE_SPECIAL',
    8: 'DIGITAL_SIGN',
    9: 'END',
}

const storeState = {
    step: 1,
    userName: '',
    gender: '',
    dni: '',
    hash: '',
    token: null,
    requestData: {},
    contracts: [],
    operation: null,
    attempts: 0,
    faceliveness_validation: 0,
    faceLivenessImageUrl: null,
    photoUri: {
        front: null,
        back: null,
        neutralSelfie: null,
        specialSelfie: null,
        randomSelfie: null,
    },
    canvasUri: null,
    loading: false,
    isModalOpen: false,
    modal: null,
    error: {
        error: false,
        type: null,
        description: null,
    },
    camera: {
        open: false,
        type: null,
    },
};

const StoreContext = React.createContext({ ...storeState });
function storeReducer (state, action) {
    switch (action.type) {
        case TYPES.STEP_FORWARD:
            console.log(state.step)
            loanevents.step(STEPS.PAGES[PAGES[state.step + 1]])
            return { ...state, step: state.step + 1 };
        case TYPES.STEP_BACKWARDS:
            loanevents.step(STEPS.PAGES[PAGES[state.step - 1]])
            return { ...state, step: state.step - 1 };
        case TYPES.SET_STEP:
            loanevents.step(STEPS.PAGES[PAGES[action.payload]])
            return { ...state, step: action.payload };
        case TYPES.SET_USER_DATA:
            const { userName, contracts, gender, dni, requestId, hash, attempts: payloadAttempts } = action.payload;
            return { ...state, userName, gender, dni, requestId, contracts, hash, attempts: payloadAttempts ?? state.attempts, operation: action.payload, faceliveness_validation: 0 };
        case TYPES.SET_ATTEMP:
            return { ...state, attempts: action.payload };
        case TYPES.DISCOUNT_ATTEMP:
            return { ...state, attempts: Math.max(state.attempts - 1, 0) };
        case TYPES.OPEN_MODAL:
            const { type, message, backdrop } = action.payload;
            return { ...state, isModalOpen: true, modal: { type, message, backdrop } };
        case TYPES.CLOSE_MODAL:
            return { ...state, isModalOpen: false };
        case TYPES.SAVE_PHOTO:
            const newPhotos = _.merge(state.photoUri, action.payload);
            return { ...state, photoUri: newPhotos };
        case TYPES.CLEAR_PHOTO:
            const photos = _.merge(state.photoUri, action.payload);
            return { ...state, photoUri: photos };
        case TYPES.SET_SIGN_CANVAS:
            return { ...state, canvasUri: action.payload };
        case TYPES.SET_TOKEN:
            return { ...state, token: action.payload };
        case TYPES.LOADING:
            return { ...state, loading: action.payload };
        case TYPES.SET_ERROR:
            return { ...state, error: { ...action.payload } };
        case TYPES.UNSET_ERROR:
            const err = { error: false, description: null, type: null };
            return { ...state, error: { ...err } };
        case TYPES.SET_CAMERA:
            return { ...state, camera: { ...action.payload } };
        case TYPES.SET_FACE_LIVENESS_IMAGE:
            return { ...state, faceLivenessImageUrl: action.payload };
        default:
            return state;
    }
};

export function useStore() {
    return React.useContext(StoreContext);
}

const fadingBackground = styled(BaseModalBackground)`
    opacity: ${p => p.opacity};
    transition: all 0.3s ease-in-out;
`;

export function ContextProvider({ children }) {
    const [store, dispatch] = useReducer(storeReducer, storeState);

    const dispatchActions = {
        clearPhoto    : (payload) => dispatch({ type: TYPES.CLEAR_PHOTO, payload }),
        closeModal    : (payload) => dispatch({ type: TYPES.CLOSE_MODAL }),
        openModal     : (payload) => dispatch({ type: TYPES.OPEN_MODAL, payload }),
        savePhoto     : (payload) => dispatch({ type: TYPES.SAVE_PHOTO, payload }),
        setCamera     : (payload) => dispatch({ type: TYPES.SET_CAMERA, payload }),
        setError      : (payload) => dispatch({ type: TYPES.SET_ERROR, payload: { ...payload, error: true } }),
        setLoading    : (payload) => dispatch({ type: TYPES.LOADING, payload }),
        setSignCanvas : (payload) => dispatch({ type: TYPES.SET_SIGN_CANVAS, payload }),
        setToken      : (payload) => dispatch({ type: TYPES.SET_TOKEN, payload }),
        setUserData   : (payload) => dispatch({ type: TYPES.SET_USER_DATA, payload }),
        setOperation  : (payload) => dispatch({ type: TYPES.SET_OPERATION, payload }),
        setAttempts   : (payload) => dispatch({ type: TYPES.SET_ATTEMP, payload }),
        discountAttemp: ()        => dispatch({ type: TYPES.DISCOUNT_ATTEMP }),
        stepBackwards : (payload) => dispatch({ type: TYPES.STEP_BACKWARDS }),
        stepForward   : (payload) => dispatch({ type: TYPES.STEP_FORWARD }),
        setStep       : (payload) => dispatch({ type: TYPES.SET_STEP, payload }),
        unsetError    : (payload) => dispatch({ type: TYPES.UNSET_ERROR }),
        setFaceLivenessImageUrl: (payload) => dispatch({ type: TYPES.SET_FACE_LIVENESS_IMAGE, payload }),
    };
    
    return (
        <ThemeProvider theme={getTheme()}>
            <StoreContext.Provider value={{ ...store, ...dispatchActions }}>
                <ModalProvider theme={getTheme()} backgroundComponent={fadingBackground}>
                    <div id="page">
                        {children}
                    </div>
                </ModalProvider>
            </StoreContext.Provider>
        </ThemeProvider>
    );
}

export default ContextProvider;
